<div class="input" [ngClass]="isRightAligned()?'right-align' : 'left-align'">
    <span class="value">{{textValue}}</span>
</div>

<div class="fake-padding" [ngClass]="isRightAligned()?'right-align' : 'left-align'"></div>
